import { createSelector } from 'reselect';

const selectGlobalServiceTypes = (state: any) => state.globalServiceTypes;


export const selectGlobalServiceTypesCurrentItem = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.current);

export const selectGlobalServiceTypesListItems = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.list);

export const selectGlobalServiceTypesItemById = (itemId: any) =>
    createSelector(selectGlobalServiceTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalServiceTypesQueryItems = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.query);

export const selectGlobalServiceTypesCreatedItem = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.create);

export const selectGlobalServiceTypesUpdatedItem = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.update);

export const selectGlobalServiceTypesReadItem = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.read);

export const selectGlobalServiceTypesDeletedItem = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.delete);

export const selectGlobalServiceTypesSearchedItems = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.search);

export const selectGlobalServiceTypesItemsCount = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.count);

export const selectGlobalServiceTypesItemsFilter = createSelector([selectGlobalServiceTypes], (globalServiceTypes) => globalServiceTypes.filter);